<template>
	<v-card>
		<SubBiddersTable>
			<template v-slot:addSubBidderAction="slotData">
				<add-sub-bidder-menu :dialog="addSubBidderMenuDialog" @close-dialog="closeDialog()"></add-sub-bidder-menu>
				<v-btn v-if="showButton" @click="handleClick()" color="primary" dark class=" ml-3 mt-3 mb-3">Dodaj subkonto</v-btn>
			</template>
		</SubBiddersTable>
	</v-card>
</template>

<script>
	import AddSubBidderMenu from "./components/AddSubBidderMenu";
	import SubBiddersTable from "./components/SubBiddersTable";
  import {User} from "../../../api/generated/User";

	export default {
    name: "SubBiddersView",

		components: {SubBiddersTable, AddSubBidderMenu},

    data() {
      return {
        addSubBidderMenuDialog: false,
        subbiderType: ""
      };
    },
    computed: {
      showButton(){
        if (this.roles.isBidder()) {
          return true;
        }
        else if (this.roles.isSubBidder() && this.subbiderType == 'SUBSIDIARY'){
          return true;
        }
        return false;
      }
    },
    methods: {
      handleClick() {
          this.addSubBidderMenuDialog = true;
      },

      closeDialog() {
        this.addSubBidderMenuDialog = false;
      }
    },
    created(){
      if(this.roles.isSubBidder()){
        User.getUserSubbiderType(
					this,
					response => {
						this.subbiderType = response;
					},
				);
      }
    }
	};
</script>
